
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { MUTATIONS } from '@/store/namespaces';
import { DriverStatusEnum } from '@/services/api-clients';
import {
  driverStatusTagColorFilter,
  driverStatusTagIconFilter,
  driverStatusTagNameFilter,
  toLowerFilter,
} from '@/filters';

@Component({
  filters: {
    driverStatusTagIconFilter,
    driverStatusTagNameFilter,
    toLowerFilter,
  },
})
export default class ReasonPrompt extends Vue {
  statusId: DriverStatusEnum = DriverStatusEnum.Problem;

  reason = '';

  reasonMaxLength = 500;

  dialog = false;

  @Mutation(MUTATIONS.FINISH_REASON_PROMPT)
  finishReasonPrompt!: (result: { saved: boolean; reason: string }) => void;

  get statusColor(): string {
    return driverStatusTagColorFilter(this.statusId)[0];
  }

  get statusTextColor(): string {
    return driverStatusTagColorFilter(this.statusId)[1];
  }

  onSave() {
    this.dialog = false;
    this.finishReasonPrompt({ saved: true, reason: this.reason });
  }

  onSkip() {
    this.dialog = false;
    this.finishReasonPrompt({ saved: false, reason: this.reason });
  }

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === MUTATIONS.SHOW_REASON_PROMPT) {
        this.statusId = state.reasonPrompt.statusId;
        this.reason = state.reasonPrompt.reason;
        this.dialog = state.reasonPrompt.isOpen;
      }
    });
  }
}
